module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-objects/project-detail-objects.component.scss
// module id = ./src/app/projects/detail/project-detail-objects/project-detail-objects.component.scss
// module chunks = main